import { z } from 'zod'
import { bigintTextSchema, lowerHexSchema } from '../../types/primitive'
import type { MoralisClient } from './client'

const transactionSchema = z.object({
  // "hash": "0x43a8a6f44f4e5b9cc9fa7e76a2b818fc76222384eb8a2fb4e3ab854523c1fb94",
  hash: lowerHexSchema,
  // "nonce": "1",
  // "transaction_index": "27",
  // "from_address_entity": null,
  // "from_address_entity_logo": null,
  // "from_address": "0xecdb93a95cab09b5a259ebac8fd48d3239a5589a",
  from_address: lowerHexSchema,
  // "from_address_label": null,
  // "to_address_entity": null,
  // "to_address_entity_logo": null,
  // "to_address": "0x213073989821f738a7ba3520c3d31a1f9ad31bbd",
  to_address: lowerHexSchema,
  // "to_address_label": null,
  // "value": "0",
  value: bigintTextSchema,
  // "gas": "392194",
  // "gas_price": "0",
  // "receipt_cumulative_gas_used": "4678646",
  // "receipt_gas_used": "169711",
  // "receipt_contract_address": null,
  // "receipt_status": "1",
  // "block_timestamp": "2021-07-28T15:28:09.000Z",
  block_timestamp: z.string().transform((x) => new Date(x).getTime()),
  // "block_number": "5304713",
  block_number: z.string().regex(/^\d+$/).transform(Number),
  // "block_hash": "0xb87e4ea5f85e16461ab3242413577b0e18c50d10f6f22454d3f8da850b4135d9",
  // "transaction_fee": "0",
  // "method_label": "settleAuction",
  // "summary": "Received 0.8 WETH from 0xe3...6b4b",
  // "possible_spam": false,
  // "category": "token receive",
  // "nft_transfers": [],
  nft_transfers: z.array(
    z.object({
      // "log_index": 132,
      // "value": "0",
      // "contract_type": "ERC721",
      // "transaction_type": "Single",
      // "token_address": "0x32950db2a7164ae833121501c797d79e7b79d74c",
      // "token_id": "2273287",
      // "from_address_entity": null,
      // "from_address_entity_logo": null,
      // "from_address": "0xecdb93a95cab09b5a259ebac8fd48d3239a5589a",
      from_address: lowerHexSchema,
      // "from_address_label": null,
      // "to_address_entity": null,
      // "to_address_entity_logo": null,
      // "to_address": "0x36b9b408da80783a360ba847303b015d7e0e59f8",
      to_address: lowerHexSchema,
      // "to_address_label": null,
      // "amount": "1",
      amount: bigintTextSchema,
      // "operator": null,
      // "possible_spam": false,
      // "verified_collection": false,
      // "direction": "send"
    }),
  ),
  // "erc20_transfers": [],
  erc20_transfers: z.array(
    z.object({
      // "token_name": "Ronin Wrapped Ether",
      // "token_symbol": "WETH",
      // "token_logo": null,
      // "token_decimals": "18",
      // "from_address_entity": null,
      // "from_address_entity_logo": null,
      // "from_address": "0xecdb93a95cab09b5a259ebac8fd48d3239a5589a",
      from_address: lowerHexSchema,
      // "from_address_label": null,
      // "to_address_entity": null,
      // "to_address_entity_logo": null,
      // "to_address": "0xa99cacd1427f493a95b585a5c7989a08c86a616b",
      to_address: lowerHexSchema,
      // "to_address_label": null,
      // "address": "0xc99a6a985ed2cac1ef41640596c5a5f9f4e19ef5",
      address: lowerHexSchema,
      // "log_index": 37,
      log_index: z.number().int(),
      // "value": "6851147569444444",
      value: bigintTextSchema,
      // "possible_spam": false,
      // "verified_contract": false,
      // "security_score": null,
      // "direction": "send",
      // "value_formatted": "0.006851147569444444"
    }),
  ),
  // "native_transfers": [],
  // "internal_transactions": [],
  internal_transactions: z.array(
    z.object({
      // "transaction_hash": "0x4f3c9722734098328c9c3b1fcddb9712f4dc6724c50ee2d3614aff6362eab175",
      // "block_number": 21021408,
      // "block_hash": "0x971595149658a4d5c2d0a2219f5019958e1a7ff2f72d7d098e144104a2a5b6a0",
      // "type": "CALL",
      // "from": "0x0000000000000068f116a894984e2db1123eb395",
      from: lowerHexSchema,
      // "to": "0x0000a26b00c1f0df003000390027140000faa719",
      to: lowerHexSchema,
      // "value": "1180000000000000",
      value: bigintTextSchema,
      // "gas": "68677",
      gas: bigintTextSchema,
      // "gas_used": "85",
      // "input": "0x",
      // "output": "0x"
    }),
  ),
})

const resultSchema = z.object({
  cursor: z.string().nullable().optional(),
  result: z.array(transactionSchema),
})

type Result = z.infer<typeof resultSchema>

const cache = new Map<string, Result>()

type GetWalletTransactionHistoryParameters = {
  client: MoralisClient
  address: string
  chain: string
  fromBlock?: number
  toBlock?: number
  cursor?: string
  headers?: Record<string, string>
}

export const getWalletTransactionHistory = async ({
  client,
  address,
  chain,
  fromBlock = 0,
  toBlock,
  cursor,
  headers,
}: GetWalletTransactionHistoryParameters) => {
  const path = `/api/v2.2/wallets/${address}/history`
  const query: Record<string, string> = {
    chain,
    from_block: fromBlock.toString(),
    include_internal_transactions: 'true',
    order: 'ASC',
  }
  if (toBlock !== undefined) {
    query.to_block = toBlock.toString()
  }
  if (cursor !== undefined) {
    query.cursor = cursor
  }

  const cacheKey = `${path}?${Object.entries(query)
    .map(([k, v]) => `${k}=${v}`)
    .join('&')}`
  const cached = cache.get(cacheKey)
  if (cached !== undefined) {
    return cached
  }

  const result = await client.get({
    path,
    query,
    resultSchema,
    headers,
  })
  cache.set(cacheKey, result)

  return result
}
